// TODO(DMD-4859): This will be removed when we upgrade the new campaign page to use Svelte
import 'flatpickr';
import {DateTime} from 'luxon';
import 'flatpickr/dist/flatpickr.css';
window.DateTime = DateTime;
